import { array } from "./array.js";
import { str } from "./str.js";
import { transform } from "./transform.js";
import { tuple } from "./tuple.js";
export function record($value) {
    return transform({
        $base: array(tuple(str, $value)),
        encode: Object.entries,
        decode: Object.fromEntries,
    });
}
//# sourceMappingURL=record.js.map